export default "__VITE_ASSET__cfbb3735__"